import { useEffect, useState } from "react"
import useCodex from "./useCodex"

const useCodexNode = (id, type) => {
  const client = useCodex()
  let [node, setNode] = useState()
  let [error, setError] = useState()
  const [loading, setLoading] = useState(true)

  const loadNode = async () => {
    setLoading(true)
    try {
      setError(null)
      let node = await client.load(id, type)
      setNode(node)
    } catch (error) {
      console.log("error loading codex node", { error })
      setError("An unexpected error occurred")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadNode()
  }, [id])

  if (node) {
    node.loading = loading
    node.refetch = loadNode
  }

  return { node, loading, error }
}

export default useCodexNode
